import { useEffect, useState } from 'react'
import { apiBlob } from '../../shared/api/http'
import { trainingApi, type TrainingClass, type TrainingImage } from './trainingApi'

const colors = ['#00d5ff', '#ffbd26', '#ff517c', '#82ef45']

export function TrainingIllustration({ image, classes }: { image: TrainingImage; classes: TrainingClass[] }) {
  const [url, setUrl] = useState('')
  const [failed, setFailed] = useState(false)
  const [zoom, setZoom] = useState(1)
  const boxes = image.isNegative ? [] : image.annotations

  useEffect(() => {
    let active = true, objectUrl = ''
    setUrl(''); setFailed(false); setZoom(1)
    apiBlob(`${trainingApi}/images/${image.id}/content`).then(blob => {
      objectUrl = URL.createObjectURL(blob)
      if (active) setUrl(objectUrl)
      else URL.revokeObjectURL(objectUrl)
    }).catch(() => { if (active) setFailed(true) })
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl) }
  }, [image.id])

  return <>
    <p>{boxes.length ? `${boxes.length} caixas salvas para treinamento. Amplie para conferir as marcações.` : image.isNegative ? 'Esta imagem foi revisada sem objetos das classes do modelo. Por isso, não há caixas marcadas.' : 'Esta imagem não possui caixas salvas.'}</p>
    <div className="training-actions" aria-label="Ampliação da ilustração">{[1, 2, 4].map(value => <button key={value} aria-pressed={zoom === value} onClick={() => setZoom(value)}>{value}×</button>)}</div>
    {failed ? <p role="alert">Não foi possível carregar a ilustração. Feche e abra novamente para tentar.</p> : !url ? <p role="status">Carregando ilustração…</p> : <div style={{ overflow: 'auto', maxHeight: '60vh' }}>
      <div style={{ position: 'relative', width: `${zoom * 100}%` }}>
        <img src={url} alt="Imagem com as marcações salvas para treinamento" onError={() => setFailed(true)} style={{ display: 'block', width: '100%', height: 'auto' }} />
        <svg aria-hidden="true" viewBox="0 0 1 1" preserveAspectRatio="none" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
          {boxes.map((box, index) => <rect key={index} x={box.centerX - box.width / 2} y={box.centerY - box.height / 2} width={box.width} height={box.height} fill="none" stroke={colors[box.classIndex % colors.length]} strokeWidth="2" vectorEffect="non-scaling-stroke" />)}
        </svg>
        {boxes.map((box, index) => <span key={index} style={{ position: 'absolute', left: `${Math.max(0, box.centerX - box.width / 2) * 100}%`, top: `${Math.max(0, box.centerY - box.height / 2) * 100}%`, color: colors[box.classIndex % colors.length], background: '#071d2bea', fontSize: 12, lineHeight: '16px', padding: '1px 3px', maxWidth: `${(1 - Math.max(0, box.centerX - box.width / 2)) * 100}%`, overflowWrap: 'anywhere', pointerEvents: 'none' }}>{classes.find(item => item.classIndex === box.classIndex)?.displayName ?? `Classe ${box.classIndex}`}</span>)}
      </div>
    </div>}
  </>
}
